import React, { useEffect } from 'react';
import { locales } from '../../../translations/locales';
import { BsFillPeopleFill, BsConeStriped, BsTruck, BsBuilding, BsArrowRightCircleFill } from 'react-icons/bs';
import Loading from '../../Loading';
import events from '../../../events';

const Dashboard = (props) => {
    const { data, locale, theme, setActivePage, ModuleRP } = props;

    useEffect(() => {
        if (data.type !== 'game') {
            ModuleRP.socket.emit(events.CONFIGURE, ModuleRP.gameId);
        }
    }, [data]);

    return (
        data.type === 'game' ?
            <div className='dashboard'>
                <div className='text-center'>
                    <h1 className={`text-center ${theme === 'DARK' ? 'text-light' : 'text-dark'}`}>{data.name}</h1>
                </div>
                <div className='row m-0'>
                    <div className='col-lg-3 col-6'>
                        <div className='small-box bg-info rounded shadow-sm text-light'>
                            <h3 className='m-2'>
                                {data.players.length}
                                <BsFillPeopleFill className='board-icon m-1' />
                            </h3>
                            <div className='m-2 board-info'>
                                {locales[locale].config.players}
                            </div>
                            <div className='board-link-bottom cursor-pointer' onClick={() => setActivePage('Players')}>
                                {locales[locale].config.moreInfos}
                                <BsArrowRightCircleFill className='ml-1' />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-6'>
                        <div className='small-box bg-warning rounded shadow-sm text-light'>
                            <h3 className='m-2'>
                                {data.missions.length}
                                <BsConeStriped className='board-icon m-1' />
                            </h3>
                            <div className='m-2 board-info'>
                                {locales[locale].config.missions}
                            </div>
                            <div className='board-link-bottom cursor-pointer' onClick={() => ModuleRP.sgo()}>
                                {locales[locale].config.moreInfos}
                                <BsArrowRightCircleFill className='ml-1' />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-6'>
                        <div className='small-box bg-success rounded shadow-sm text-light'>
                            <h3 className='m-2'>
                                {data.vehicleModels.length}
                                <BsTruck className='board-icon m-1' />
                            </h3>
                            <div className='m-2 board-info'>
                                {locales[locale].config.vehicleModels}
                            </div>
                            <div className='board-link-bottom cursor-pointer' onClick={() => setActivePage('VehicleModels')}>
                                {locales[locale].config.moreInfos}
                                <BsArrowRightCircleFill className='ml-1' />
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-3 col-6'>
                        <div className='small-box bg-danger rounded shadow-sm text-light'>
                            <h3 className='m-2'>
                                {data.buildings.length}
                                <BsBuilding className='board-icon m-1' />
                            </h3>
                            <div className='m-2 board-info'>
                                {locales[locale].config.buildings}
                            </div>
                            <div className='board-link-bottom cursor-pointer' onClick={() => setActivePage('Buildings')}>
                                {locales[locale].config.moreInfos}
                                <BsArrowRightCircleFill className='ml-1' />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    data.type === 'game' && (!data.options.configPackBeginner.active || data.buildings.length === 0) &&
                    <div className='row'>
                        <div className={`col-4 m-5 p-1 border border-solid border-${theme === 'DARK' ? 'light' : 'dark'} 
                     ${theme === 'DARK' ? 'bg-dark text-light' : 'bg-light text-dark'}`}>
                            <h2>{locales[locale].shop.configPackBeginner}</h2>
                            <p>{locales[locale].shop.configPackBeginnerDesc.split('<br />').map((text, index) => (
                                <React.Fragment key={index}>
                                    {index > 0 && <br />}
                                    {text}
                                </React.Fragment>
                            ))}</p>
                            <button
                                className='btn btn-sm btn-success float-right'
                                id='btn-buyOption-configPackBeginner'
                                onClick={() => ModuleRP.buyOption('configPackBeginner')}
                            >
                                {locales[locale].shop.buyConfigPackBeginner}
                            </button>
                        </div>
                    </div>
                }
            </div> :
            <Loading theme={theme} />
    );
};

export default Dashboard;
